import React from 'react'
import {
  Box,
  Box as LeftHeaderWrapper,
  Box as RightHeaderWrapper,
} from '@node-space/storybook-components/dist/Box'
import Breadcrumbs, { type CustomBreadCrumbConfig } from 'components/Breadcrumbs'
import { DarkModeToggle } from 'components/DarkModeToggle'

interface HeaderProps {
  isTitleEnabled?: boolean
  breadcrumbConfig?: CustomBreadCrumbConfig[]
}

const Header = ({ isTitleEnabled, breadcrumbConfig }: HeaderProps) => {
  return (
    <header className="sticky top-0 z-30">
      <Box paddingX={16} paddingY={12} className="sm:px-6 lg:px-8">
        <Box flex alignItems="center" justifyContent="between" height={40}>
          <LeftHeaderWrapper flex alignItems="center">
            {isTitleEnabled && <Breadcrumbs customConfig={breadcrumbConfig} />}
          </LeftHeaderWrapper>

          <RightHeaderWrapper flex alignItems="center">
            <DarkModeToggle />
          </RightHeaderWrapper>
        </Box>
      </Box>
    </header>
  )
}

export default Header
